module.exports = {"140722100":"辽阳镇","140722101":"桐峪镇","140722102":"麻田镇","140722103":"芹泉镇","140722104":"拐儿镇","140722200":"寒王乡","140722201":"石匣乡","140722204":"羊角乡","140722400":"城区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140722.json
// module id = 412
// module chunks = 0